import React, { useState, useEffect, useRef } from 'react'
import { Form, Button } from 'react-bootstrap'

function SelectFilterPopover({
  column,
  params,
  setParams,
  options = [],
  onClose,
  onSetHandleApply,
  canEdit = true,
  hideApplyButton = false
}) {
  const accessorKey = column.accessor_key
  const [currentValue, setCurrentValue] = useState(params[accessorKey] || '')

  // Track initial value to detect changes
  const initialValue = useRef(params[accessorKey] || '')

  const handleChange = (e) => {
    if (!canEdit) return
    const newValue = e.target.value
    setCurrentValue(newValue)
  }

  const handleApply = () => {
    // Only update params if value has changed
    if (currentValue !== initialValue.current) {
      setParams((p) => ({ ...p, [accessorKey]: currentValue }))
    }
    onClose()
  }

  useEffect(() => {
    if (onSetHandleApply) {
      onSetHandleApply(handleApply)
    }
  }, [currentValue]) // eslint-disable-line react-hooks/exhaustive-deps

  // Auto-apply changes when hideApplyButton is true
  useEffect(() => {
    if (hideApplyButton) {
      setParams((p) => ({ ...p, [accessorKey]: currentValue }))
    }
  }, [currentValue, hideApplyButton, setParams, accessorKey])

  const handleClear = () => {
    setCurrentValue('')
    setParams((p) => ({ ...p, [accessorKey]: '' }))
  }

  return (
    <div>
      <div className="mb-3">
        <strong>{column.name}</strong>
      </div>

      <div className="mb-3">
        <Form.Select value={currentValue} onChange={handleChange} size="sm" disabled={!canEdit}>
          <option value="">Select {column.name}</option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Form.Select>
      </div>

      {!hideApplyButton && (
        <div className="d-flex justify-content-between gap-2">
          {canEdit && (
            <Button variant="light" size="sm" onClick={handleClear}>
              Clear
            </Button>
          )}
          <Button variant="primary" size="sm" onClick={canEdit ? handleApply : onClose}>
            {canEdit ? 'Apply' : 'Close'}
          </Button>
        </div>
      )}
    </div>
  )
}

export default SelectFilterPopover
